import ListAjeerAppliedList from "./ListAjeerAppliedList";
import { getAjeerData } from "../../../../../store/Api";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";

export let sectorArray = [];

export default function AjeerAppliedList() {
  const Client = useSelector((state) => state.ajeerData);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("nodeToken");

  useEffect(() => {
    dispatch(getAjeerData(token));
  }, []);
  const updateData = () => {
    dispatch(getAjeerData(token));
  };
  console.log("updated data.........", Client);
  return (
    <>
      <div className="p-2  sm:p-5 ">
        {!Client.data.loading ? (
          <ListAjeerAppliedList
            callBack={updateData}
            list={Client}
            token={token}
            uploadFile={""}
            loading={loading}
            titles={[
              "SR.NO.",
              "employee ID",
              "employee NAME",
              "SPONSOR",
              "CLIENT NAME",
              "VISA PROVIDER",
              "IQAMA NUMBER",
              "AJEER LOCATION ENGLISH",
              "AJEER LOCATION ARABIC",
              "AJEER APPLY DATE",
              "AJEER ISSUE DATE",
              "AJEER EXPIRE DATE",
              "AJEER VALID DAYS",
              "STATUS",
              "ACTION",
            ]}
          />
        ) : (
          <LoadingWithLable />
        )}
      </div>
    </>
  );
}
